module.exports = __webpack_public_path__ + "static/media/background-graphic.74eae248.svg";